var _g, _g2, _g3, _path, _path2, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgReducingComplianceRisk(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 60,
    viewBox: "0 0 60 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_b_24786_52412)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 18.5882,
    cy: 8.85187,
    r: 7.85187,
    fill: "url(#paint0_linear_24786_52412)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 18.5882,
    cy: 8.85187,
    r: 7.85187,
    fill: "url(#paint1_radial_24786_52412)",
    fillOpacity: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 18.5882,
    cy: 8.85187,
    r: 7.85187,
    fill: "url(#paint2_linear_24786_52412)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 18.5882,
    cy: 8.85187,
    r: 7.35187,
    stroke: "url(#paint3_radial_24786_52412)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 18.5882,
    cy: 8.85187,
    r: 7.35187,
    stroke: "url(#paint4_radial_24786_52412)"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_b_24786_52412)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "path-3-inside-1_24786_52412",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M34.6664 36.3332C35.771 36.3332 36.6782 35.4348 36.5534 34.3373C36.1043 30.3864 34.3312 26.6802 31.492 23.841C28.1788 20.5278 23.6852 18.6665 18.9997 18.6665C14.3142 18.6665 9.82062 20.5278 6.50747 23.841C3.66821 26.6802 1.89517 30.3864 1.44605 34.3373C1.32129 35.4348 2.22844 36.3332 3.33301 36.3332L18.9997 36.3332H34.6664Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M34.6664 36.3332C35.771 36.3332 36.6782 35.4348 36.5534 34.3373C36.1043 30.3864 34.3312 26.6802 31.492 23.841C28.1788 20.5278 23.6852 18.6665 18.9997 18.6665C14.3142 18.6665 9.82062 20.5278 6.50747 23.841C3.66821 26.6802 1.89517 30.3864 1.44605 34.3373C1.32129 35.4348 2.22844 36.3332 3.33301 36.3332L18.9997 36.3332H34.6664Z",
    fill: "url(#paint5_linear_24786_52412)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.6664 36.3332C35.771 36.3332 36.6782 35.4348 36.5534 34.3373C36.1043 30.3864 34.3312 26.6802 31.492 23.841C28.1788 20.5278 23.6852 18.6665 18.9997 18.6665C14.3142 18.6665 9.82062 20.5278 6.50747 23.841C3.66821 26.6802 1.89517 30.3864 1.44605 34.3373C1.32129 35.4348 2.22844 36.3332 3.33301 36.3332L18.9997 36.3332H34.6664Z",
    fill: "url(#paint6_radial_24786_52412)",
    fillOpacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.6664 36.3332C35.771 36.3332 36.6782 35.4348 36.5534 34.3373C36.1043 30.3864 34.3312 26.6802 31.492 23.841C28.1788 20.5278 23.6852 18.6665 18.9997 18.6665C14.3142 18.6665 9.82062 20.5278 6.50747 23.841C3.66821 26.6802 1.89517 30.3864 1.44605 34.3373C1.32129 35.4348 2.22844 36.3332 3.33301 36.3332L18.9997 36.3332H34.6664Z",
    fill: "url(#paint7_linear_24786_52412)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.6664 36.3332C35.771 36.3332 36.6782 35.4348 36.5534 34.3373C36.1043 30.3864 34.3312 26.6802 31.492 23.841C28.1788 20.5278 23.6852 18.6665 18.9997 18.6665C14.3142 18.6665 9.82062 20.5278 6.50747 23.841C3.66821 26.6802 1.89517 30.3864 1.44605 34.3373C1.32129 35.4348 2.22844 36.3332 3.33301 36.3332L18.9997 36.3332H34.6664Z",
    stroke: "url(#paint8_radial_24786_52412)",
    strokeWidth: 2,
    mask: "url(#path-3-inside-1_24786_52412)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.6664 36.3332C35.771 36.3332 36.6782 35.4348 36.5534 34.3373C36.1043 30.3864 34.3312 26.6802 31.492 23.841C28.1788 20.5278 23.6852 18.6665 18.9997 18.6665C14.3142 18.6665 9.82062 20.5278 6.50747 23.841C3.66821 26.6802 1.89517 30.3864 1.44605 34.3373C1.32129 35.4348 2.22844 36.3332 3.33301 36.3332L18.9997 36.3332H34.6664Z",
    stroke: "url(#paint9_radial_24786_52412)",
    strokeWidth: 2,
    mask: "url(#path-3-inside-1_24786_52412)"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter2_b_24786_52412)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M27.6704 51.7639L40.1426 58L52.6147 51.7639C56.0026 50.07 58.1426 46.6074 58.1426 42.8197V21.5556C58.1426 20.6406 57.5249 19.8469 56.6289 19.6615C53.872 19.0911 47.621 18 40.1426 18C32.6641 18 26.4132 19.0911 23.6563 19.6615C22.7603 19.8469 22.1426 20.6406 22.1426 21.5556V42.8197C22.1426 46.6074 24.2826 50.07 27.6704 51.7639Z",
    fill: "url(#paint10_linear_24786_52412)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.6704 51.7639L40.1426 58L52.6147 51.7639C56.0026 50.07 58.1426 46.6074 58.1426 42.8197V21.5556C58.1426 20.6406 57.5249 19.8469 56.6289 19.6615C53.872 19.0911 47.621 18 40.1426 18C32.6641 18 26.4132 19.0911 23.6563 19.6615C22.7603 19.8469 22.1426 20.6406 22.1426 21.5556V42.8197C22.1426 46.6074 24.2826 50.07 27.6704 51.7639Z",
    fill: "url(#paint11_radial_24786_52412)",
    fillOpacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.1426 57.441L27.894 51.3167C24.6756 49.7075 22.6426 46.418 22.6426 42.8197V21.5556C22.6426 20.8665 23.1046 20.2862 23.7576 20.1511C26.4944 19.5849 32.7094 18.5 40.1426 18.5C47.5757 18.5 53.7908 19.5849 56.5276 20.1511C57.1806 20.2862 57.6426 20.8665 57.6426 21.5556V42.8197C57.6426 46.418 55.6096 49.7075 52.3911 51.3167L40.1426 57.441Z",
    stroke: "url(#paint12_radial_24786_52412)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.1426 57.441L27.894 51.3167C24.6756 49.7075 22.6426 46.418 22.6426 42.8197V21.5556C22.6426 20.8665 23.1046 20.2862 23.7576 20.1511C26.4944 19.5849 32.7094 18.5 40.1426 18.5C47.5757 18.5 53.7908 19.5849 56.5276 20.1511C57.1806 20.2862 57.6426 20.8665 57.6426 21.5556V42.8197C57.6426 46.418 55.6096 49.7075 52.3911 51.3167L40.1426 57.441Z",
    stroke: "url(#paint13_radial_24786_52412)"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M36.7071 35.2071L40 38.5L47.7929 30.7071C48.1834 30.3166 48.8166 30.3166 49.2071 30.7071L50.777 32.277C51.1737 32.6737 51.1665 33.319 50.7611 33.7068L40.6811 43.3486C40.2986 43.7144 39.6972 43.7189 39.3094 43.3587L33.7604 38.2061C33.3451 37.8204 33.333 37.167 33.7338 36.7662L35.2929 35.2071C35.6834 34.8166 36.3166 34.8166 36.7071 35.2071Z",
    fill: "#88A2B1",
    fillOpacity: 0.2
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M35.7071 34.2071L39 37.5L46.7929 29.7071C47.1834 29.3166 47.8166 29.3166 48.2071 29.7071L49.777 31.277C50.1737 31.6737 50.1665 32.319 49.7611 32.7068L39.6811 42.3486C39.2986 42.7144 38.6972 42.7189 38.3094 42.3587L32.7604 37.2061C32.3451 36.8204 32.333 36.167 32.7338 35.7662L34.2929 34.2071C34.6834 33.8166 35.3166 33.8166 35.7071 34.2071Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_b_24786_52412",
    x: 4.73633,
    y: -5,
    width: 27.7041,
    height: 27.7036,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImageFix",
    stdDeviation: 3
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_24786_52412"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_backgroundBlur_24786_52412",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_b_24786_52412",
    x: -4.56543,
    y: 12.6665,
    width: 47.1299,
    height: 29.6665,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImageFix",
    stdDeviation: 3
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_24786_52412"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_backgroundBlur_24786_52412",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_b_24786_52412",
    x: 16.1426,
    y: 12,
    width: 48,
    height: 52,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImageFix",
    stdDeviation: 3
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_24786_52412"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_backgroundBlur_24786_52412",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_24786_52412",
    x1: 11.2271,
    y1: 0.458492,
    x2: 23.3043,
    y2: 17.74,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F09C9C",
    stopOpacity: 0.5
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A6D7F0",
    stopOpacity: 0.3
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint1_radial_24786_52412",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(11.2271 0.458492) scale(14.7223 20.5773)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_24786_52412",
    x1: 10.7363,
    y1: 1,
    x2: 18.5882,
    y2: 16.7037,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFA300"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF0400"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint3_radial_24786_52412",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(7.79188 8.31036) rotate(37.113) scale(10.7693 11.1102)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint4_radial_24786_52412",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(23.4956 -0.624526) rotate(122.39) scale(6.41278 6.17446)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_24786_52412",
    x1: 2.43718,
    y1: 17.4481,
    x2: 25.2417,
    y2: 41.3655,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F09C9C",
    stopOpacity: 0.5
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A6D7F0",
    stopOpacity: 0.3
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint6_radial_24786_52412",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(2.43718 17.4481) scale(33.1251 46.299)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_24786_52412",
    x1: 1.33301,
    y1: 18.6665,
    x2: 18.9997,
    y2: 53.9999,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFA300"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF0400"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint8_radial_24786_52412",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(-5.29201 35.1148) rotate(37.113) scale(24.231 24.998)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint9_radial_24786_52412",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(30.0414 15.0113) rotate(122.39) scale(14.4287 13.8925)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_24786_52412",
    x1: 23.2676,
    y1: 19,
    x2: 43.573,
    y2: 55.0688,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F09C9C",
    stopOpacity: 0.5
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A6D7F0",
    stopOpacity: 0.3
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint11_radial_24786_52412",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(23.2676 19) scale(33.75 38)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint12_radial_24786_52412",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(15.3926 33.5) rotate(31.3633) scale(23.0564 21.9692)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint13_radial_24786_52412",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(51.3926 17) rotate(128.22) scale(12.7285 13.1692)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReducingComplianceRisk);
export default __webpack_public_path__ + "static/media/reducingComplianceRisk.500a7d274f7e2616537390efbcb2c507.svg";
export { ForwardRef as ReactComponent };